import React from "react";
import Page from "./../components/Page";
import SEO from "./../components/SEO";
import WithSideNav from "../components/WithSideNav";

import Section from "../components/Section";
import EmailForm from "../components/EmailForm";

const sideNavProps = [
  {
    title: "About Us",
    link: "/about"
  },
  {
    title: "Team & Collaborators",
    link: "/team"
  },
  {
    title: "Support & Collaborate",
    link: "/get-support"
  },
  {
    title: "Funding History",
    link: "/history"
  }
];

function TeamPage() {
  return (
    <Page>
      <SEO title="Get Support | OHIF" />
      <Section>
        <WithSideNav sideNavProps={sideNavProps} title="Support & Collaborate">
          <p>
            Developed through a collaboration between the MGH Department of Radiology and Radical Imaging, OHIF has grown into the most widely used open-source web-based medical imaging viewer. We actively support the community through{' '}
            <a
              href="https://join.slack.com/t/cornerstonejs/shared_invite/zt-3108kuc8m-ON1zP3nWsrgPNv9mM0E5fw"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-100 hover:opacity-75"
            >
              Slack
            </a>{' '}
            and{' '}
            <a
              href="https://github.com/OHIF/OHIF-Office-Hours"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-100 hover:opacity-75"
            >
              Office hours
            </a>
            . If you need additional technical support or custom software development collaboration, please complete the form below and a member of our OHIF team will get in touch with you.
          </p>
          <p className="text-[#5acce6] text-[25px] leading-[37px] font-light mt-8">
            Complete the form below and a member of<br />
            the OHIF team will get in touch soon
          </p>
          <EmailForm />
        </WithSideNav>
      </Section>
    </Page>
  );
}

export default TeamPage;
